import { WebshopConfig } from '../types';

// Webshop konfigurációk különböző URL-ekhez
export const WEBSHOP_CONFIGS: Record<string, WebshopConfig> = {
  // Alapértelmezett webshop (localhost:3000)
  'default': {
    // Alapvető azonosítók
    webshopId: 'lmweb1',
    webshopName: 'LaptopMarket',
    webshopUrl: 'laptopmarket.hu',
    organizationId: 'jHCLNE893sT3icRQ5GZd',
    organizationName: 'LaptopMarket Webshop',
    warehouseId: 'lmweb1',
    allowedWarehouseIds: ['lmweb1'],
    // Dinamikusan kiolvasva a CRM raktár beállításaiból (allowOnlineOrders: true)
    
    // Pénzügyi beállítások
    currency: 'HUF',
    defaultTaxRate: 27,
    
    // Vizuális beállítások
    logoUrl: '/logo.png',
    primaryColor: '#3B82F6',
    secondaryColor: '#1E40AF',
    faviconUrl: '/favicon.ico',
    
    // Kapcsolattartási adatok
    contactEmail: 'info@laptopmarket.hu',
    contactPhone: '+36 701 908 3086',
    supportEmail: 'support@laptopmarket.hu',
    address: {
      street: 'Példa utca 123',
      city: 'Budapest',
      postalCode: '1234',
      country: 'Magyarország'
    },
    
    // SEO adatok
    metaTitle: 'LaptopMarket - Minőségi laptopok és notebookok',
    metaDescription: 'Új és használt laptopok széles választéka kedvező áron. Gyors szállítás országosan, garanciával.',
    
    // Fizetési opciók
    paymentMethods: ['card', 'transfer', 'cash_on_delivery'],
    shippingMethods: ['standard', 'express', 'pickup'],
    freeShippingThreshold: 50000,
    
    // Funkciók
    features: {
      showStockLevels: true,
      allowBackorders: false,
      requireCustomerRegistration: false,
      enableWishlist: true,
      enableProductReviews: true,
      enableStockNotifications: true,
      enableLiveChat: false,
      enableGoogleAnalytics: true,
      enableFacebookPixel: false
    }
  },
  
  // Második webshop (pl. shop2.laptopmarket.hu)
  'shop2': {
    // Alapvető azonosítók
    webshopId: 'shop2',
    webshopName: 'LaptopMarket Debrecen',
    webshopUrl: 'shop2.youcrm.hu',
    organizationId: 'shop2-org-id',
    organizationName: 'LaptopMarket Shop 2',
    warehouseId: 'shop2-warehouse-id',
    allowedWarehouseIds: ['shop2-warehouse-id'],
    
    // Pénzügyi beállítások
    currency: 'HUF',
    defaultTaxRate: 27,
    
    // Vizuális beállítások
    logoUrl: '/logo-shop2.png',
    primaryColor: '#10B981',
    secondaryColor: '#059669',
    faviconUrl: '/favicon-shop2.ico',
    
    // Kapcsolattartási adatok
    contactEmail: 'shop2@laptopmarket.hu',
    contactPhone: '+36 1 234 5679',
    supportEmail: 'support2@laptopmarket.hu',
    address: {
      street: 'Másik utca 456',
      city: 'Debrecen',
      postalCode: '4000',
      country: 'Magyarország'
    },
    
    // SEO adatok
    metaTitle: 'LaptopMarket Debrecen - Laptopok Kelet-Magyarországon',
    metaDescription: 'Debreceni laptop szaküzlet. Gyors kiszállítás Hajdú-Bihar megyében.',
    
    // Fizetési opciók
    paymentMethods: ['card', 'transfer', 'cash_on_delivery'],
    shippingMethods: ['standard', 'express', 'pickup'],
    freeShippingThreshold: 40000,
    
    // Funkciók
    features: {
      showStockLevels: true,
      allowBackorders: true,
      requireCustomerRegistration: false,
      enableWishlist: true,
      enableProductReviews: true,
      enableStockNotifications: true,
      enableLiveChat: true,
      enableGoogleAnalytics: true,
      enableFacebookPixel: true
    }
  },
  
  // Harmadik webshop (pl. shop3.laptopmarket.hu)
  'shop3': {
    // Alapvető azonosítók
    webshopId: 'shop3',
    webshopName: 'LaptopMarket Szeged',
    webshopUrl: 'shop3.youcrm.hu',
    organizationId: 'shop3-org-id',
    organizationName: 'LaptopMarket Shop 3',
    warehouseId: 'shop3-warehouse-id',
    allowedWarehouseIds: ['shop3-warehouse-id'],
    
    // Pénzügyi beállítások
    currency: 'HUF',
    defaultTaxRate: 27,
    
    // Vizuális beállítások
    logoUrl: '/logo-shop3.png',
    primaryColor: '#F59E0B',
    secondaryColor: '#D97706',
    faviconUrl: '/favicon-shop3.ico',
    
    // Kapcsolattartási adatok
    contactEmail: 'shop3@laptopmarket.hu',
    contactPhone: '+36 1 234 5680',
    supportEmail: 'support3@laptopmarket.hu',
    address: {
      street: 'Harmadik utca 789',
      city: 'Szeged',
      postalCode: '6720',
      country: 'Magyarország'
    },
    
    // SEO adatok
    metaTitle: 'LaptopMarket Szeged - Dél-magyarországi laptop centrum',
    metaDescription: 'Szegedi laptop kereskedés. Professzionális tanácsadás és szerviz.',
    
    // Fizetési opciók
    paymentMethods: ['card', 'transfer'],
    shippingMethods: ['standard', 'pickup'],
    freeShippingThreshold: 30000,
    
    // Funkciók
    features: {
      showStockLevels: false,
      allowBackorders: false,
      requireCustomerRegistration: true,
      enableWishlist: false,
      enableProductReviews: true,
      enableStockNotifications: false,
      enableLiveChat: false,
      enableGoogleAnalytics: true,
      enableFacebookPixel: false
    }
  }
};

// Aktuális webshop konfiguráció meghatározása
export const getCurrentWebshopConfig = (): WebshopConfig => {
  const hostname = window.location.hostname;
  
  // URL alapú webshop azonosítás
  if (hostname.includes('shop2')) {
    return WEBSHOP_CONFIGS.shop2;
  } else if (hostname.includes('shop3')) {
    return WEBSHOP_CONFIGS.shop3;
  } else if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    // Fejlesztési környezet - URL paraméter alapján
    const urlParams = new URLSearchParams(window.location.search);
    const shopId = urlParams.get('shop');
    if (shopId && WEBSHOP_CONFIGS[shopId]) {
      return WEBSHOP_CONFIGS[shopId];
    }
    return WEBSHOP_CONFIGS.default;
  }
  
  // Alapértelmezett webshop
  return WEBSHOP_CONFIGS.default;
};

// Webshop specifikus beállítások
export const getWebshopSettings = () => {
  const config = getCurrentWebshopConfig();
  
  return {
    // Webshop azonosítás - FONTOS: rendelésekhez!
    webshopId: config.webshopId,
    webshopName: config.webshopName,
    webshopUrl: config.webshopUrl,
    
    // Szervezet és raktár beállítások
    organizationId: config.organizationId,
    organizationName: config.organizationName,
    warehouseId: config.warehouseId,
    allowedWarehouseIds: config.allowedWarehouseIds,
    
    // Árazási beállítások
    currency: config.currency,
    defaultTaxRate: config.defaultTaxRate,
    
    // Vizuális beállítások
    logoUrl: config.logoUrl,
    primaryColor: config.primaryColor,
    secondaryColor: config.secondaryColor,
    faviconUrl: config.faviconUrl,
    bannerImageUrl: config.bannerImageUrl,
    
    // Kapcsolattartási adatok
    contactEmail: config.contactEmail,
    contactPhone: config.contactPhone,
    supportEmail: config.supportEmail,
    address: config.address,
    
    // SEO és meta adatok
    metaTitle: config.metaTitle,
    metaDescription: config.metaDescription,
    metaKeywords: config.metaKeywords,
    
    // Üzleti információk
    businessHours: config.businessHours,
    
    // E-commerce beállítások
    paymentMethods: config.paymentMethods,
    shippingMethods: config.shippingMethods,
    freeShippingThreshold: config.freeShippingThreshold,
    
    // Webshop specifikus funkciók
    features: config.features || {
      showStockLevels: true,
      allowBackorders: false,
      requireCustomerRegistration: false,
      enableWishlist: true,
      enableProductReviews: true,
      enableStockNotifications: true,
      enableLiveChat: false,
      enableGoogleAnalytics: false,
      enableFacebookPixel: false
    }
  };
};

// Készlet szűrés webshop specifikusan
export const getInventoryFilter = () => {
  const config = getCurrentWebshopConfig();
  
  return {
    organizationId: config.organizationId,
    // warehouseIds dinamikusan kiolvasva a productService.getProductInventory()-ban
    onlyInStock: true, // Csak készleten lévő termékek
    includeDiscontinued: false // Kifutó termékek ne jelenjenek meg
  };
};

// Termék szűrés webshop specifikusan
export const getProductFilter = () => {
  const config = getCurrentWebshopConfig();
  
  return {
    organizationId: config.organizationId,
    webStore: true, // Csak webáruházban megjelenő termékek
    isActive: true, // Csak aktív termékek
    discontinued: false // Kifutó termékek ne jelenjenek meg
  };
}; 